import { load } from '@/router/routes/index';

export default [
    {
        path: 'quotes',
        name: 'quote.index',
        component: load('quote/QuoteIndex'),
        meta: { auth: true },
    },
    {
        path: 'quotes/create',
        name: 'quote.create',
        component: load('quote/QuoteCreate'),
        meta: { auth: true, forceCollapsedMenu: true },
    },
    {
        path: 'quotes/:quoteId',
        component: load('quote/QuoteDetail'),
        meta: { auth: true },
        children: [
            {
                path: '',
                component: load('quote/QuoteShow'),
                meta: { auth: true },
                children: [
                    {
                        path: '',
                        name: 'quote.show',
                        component: load('quote/QuoteShowOverview'),
                        meta: { auth: true },
                    },
                    {
                        path: 'quote-rows',
                        name: 'quote.show.quote-rows',
                        component: load('quote/QuoteRowsShow'),
                        meta: { auth: true },
                    }
                ],
            },
            {
                path: 'edit',
                name: 'quote.edit',
                component: load('quote/QuoteEdit'),
                meta: { auth: true, forceCollapsedMenu: true },
            }
        ],
    }
];
